<template>
  <div class="media-page">
    <DrawView
      v-if="media"
      v-model="media.croquis"
      :background-image="media.image"
      @on-save="save"
      @go-back="$router.go(-1)"
    />
  </div>
</template>

<script>
import DrawView from "@/views/components/DrawView.vue";

export default {
  name: "MediaPage",

  components: {
    DrawView
  },

  props: {
    projectUuid: { type: String, default: "" },
    uuid: { type: String, default: "" }
  },

  data() {
    return {
      media: null
    };
  },

  created() {
    this.getMedia();
  },

  methods: {
    /**
     * Save new media
     */
    async save(media) {
      console.log("Saving");
      // await this.$store.dispatch("medias/updateSketchMedia", {
      //   project_uuid: this.projectUuid,
      //   media_uuid: this.uuid,
      //   payload: { croquis: media.sketch }
      // });

      await this.$db.medias.update(this.uuid, { croquis: media.sketch });

      await this.getMedia();

      this.$router.go(-1);
    },

    /**
     * Get media
     */
    async getMedia() {
      // let media = await this.$store.dispatch("medias/getMedia", {
      //   project_uuid: this.projectUuid,
      //   media_uuid: this.uuid
      // });

      let media = await this.$db.medias.get(this.uuid);

      // Get image
      // if (media.has_image) {
      //   const { image } = await this.$store.dispatch("medias/getMediaImage", {
      //     project_uuid: this.projectUuid,
      //     media_uuid: this.uuid
      //   });

      //   media = Object.assign(media, { image });
      // }

      this.media = media;
    }
  }
};
</script>
